/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-02-13.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-02-13.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-02-13.mdx';

const metadata = {
  slug: "2020-02-13",
  title: "Classroom and Two Years in NYC",
  author: "Christian Battaglia",
  description: "Amplify is about to ship Classroom — a product that lets teachers launch lessons in seconds. Also: reflecting on two years in New York City since that first moving trip with plastic lidded boxes from Walmart.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-02-13T00:00:00.000Z",
  
  readTime: "2 min read",
  tags: ["Amplify","Classroom","EdTech","product launch","NYC","career","Google Slides","teaching"],
};

export const Route = createFileRoute('/blog/posts/2020-02-13')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-02-13',
    image: '/og/blog/2020-02-13.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
